import React from 'react';
import { getWebComponentUrl } from "./MyKBBUrls";
export default ({
  userwcbranch
}) => [...[React.createElement("script", {
  async: true,
  key: "authScript",
  type: "module",
  src: getWebComponentUrl({
    userwcbranch
  })
}), React.createElement("script", {
  async: true,
  key: "authScriptNoModule",
  noModule: true,
  src: getWebComponentUrl({
    userwcbranch
  })
})]];